import { Button, Modal, Form, Input, message } from "antd";
import { updatePassword } from "@/apis/user";
import intl from "react-intl-universal";
import { useEffect } from "react";
import { encrypt } from "@/utils/jsencrypt"

const UpdataPassword = ({ isPassword, setIsPassword, uuid }) => {
	const [form] = Form.useForm();
	const msg = intl.get("Please complete this required field")

	// 编辑
	const onFinish = (values) => {
		updatePassword({
			userUuid: uuid,
			password: encrypt(values.password),
			newPassword: encrypt(values.newPassword)
		}).then(res => {
			message.success(intl.get("Operate successfully"))
			setIsPassword(false)
		}).catch(err => {
		})
	}
	useEffect(() => {
		if (isPassword) {
			form.setFieldsValue({
				password: "",
				newPassword: "",
				password2: ""
			})
		}
	}, [isPassword])

	return (
		<Modal
			title={intl.get("Change Password")}
			width={500}
			open={isPassword}
			footer={null}
			onCancel={() => {
				setIsPassword(false)
			}}>
			<Form
				form={form}
				style={{ marginTop: 30 }}
				onFinish={onFinish}
				autoComplete="off"
				layout="vertical"
			>
				<Form.Item
					label={intl.get('Old password')}
					name="password"
					rules={[
						{
							required: true,
							message: msg,
						},
					]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item
					label={intl.get('User.New password')}
					name="newPassword"
					rules={[
						{
							required: true,
							message: msg,
						},
					]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item
					label={intl.get("Register.Confirm Password")}
					name="password2"
					dependencies={['password']}
					rules={[
						{
							required: true,
							message: msg,
						},
						({ getFieldValue }) => ({
							validator(_, value) {
								if (!value || getFieldValue('newPassword') === value) {
									return Promise.resolve();
								}
								return Promise.reject(new Error(intl.get('The new password that you entered do not match')));
							},
						}),
					]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item>
					<Button type="primary" htmlType="submit">
						{intl.get("Share.Submit")}
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default UpdataPassword;